import noop from 'lodash/noop'
import MapLibre, { NavigationControl, type MapRef } from 'react-map-gl/maplibre'

import 'maplibre-gl/dist/maplibre-gl.css'

import React from 'react'

import config from '@/config'
import { zoomLevels } from '@/features/ListingsMap/lib'

const { MAP_SERVER } = config

type ControlPosition = 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left'
export interface Props {
  children: React.ReactNode
  onInit?: (m: MapRef) => void
  onChange?: () => {}
  zoom?: number
  center: [number, number]
  maxZoom?: number
  scrollZoom?: boolean
  navigationControl?: {
    enabled: boolean
    compass?: boolean
    position?: ControlPosition
  }
}

const MAX_ZOOM = zoomLevels.max

const Map = React.forwardRef<MapRef, Props>(
  (
    {
      children,
      onInit = noop,
      onChange = noop,
      zoom = 11,
      center,
      maxZoom = MAX_ZOOM,
      navigationControl = {
        enabled: true,
        position: 'bottom-right',
        compass: true
      },
      ...rest
    },
    ref
  ) => {
    return (
      <MapLibre
        ref={ref}
        initialViewState={{
          longitude: center[1],
          latitude: center[0],
          zoom
        }}
        interactiveLayerIds={['places']}
        cursor="auto"
        onLoad={onInit}
        onMoveEnd={onChange}
        style={{ height: '100%', width: '100%' }}
        mapStyle={`${MAP_SERVER}/styles/bright/style.json`}
        maxZoom={maxZoom}
        minZoom={3}
        attributionControl={false}
        // maxBounds={MAX_BOUNDS}
        {...rest}
      >
        {navigationControl.enabled && (
          <NavigationControl
            position={navigationControl.position}
            showCompass={navigationControl.compass}
          />
        )}
        {children}
      </MapLibre>
    )
  }
)

Map.displayName = 'Map'

export default Map
